import React from 'react';
import SvgIcon from './svg-icon.jsx';

export default function AngkasBrandLogo({
  className = '',
  width = 56,
  height = 10,
  title = 'ANGKAS',
  ...props
}) {
  return (
    <SvgIcon
      name="angkas-brand"
      viewBox="0 0 56 10"
      width={width}
      height={height}
      className={className}
      title={title}
      {...props}
    />
  );
}
